import { observable } from "mobx";
import FormStore from "~/stores/FormStore";
import CreditCardStore from "~/stores/Credit/CreditCardStore";

class CreditCardFormStore {
  @observable formStore = null;

  @observable creditCardStore = null;

  constructor() {
    this.formStore = new FormStore({
      nameOnCard: "",
      street: "",
      street2: "",
      city: "",
      state: "",
      saveCreditCard: true,
      isDefault: false,
    });

    this.creditCardStore = new CreditCardStore();
  }
}

export default CreditCardFormStore;
